import { apiBasePath } from '@/utils/apiBasePath';
import {
  BlogApi,
  Configuration,
  type BlogApiListBlogsRequest,
  type CreateBlogRequest,
  type UpdateBlogRequest,
} from '@teemill/blog';
import { toValue } from 'vue';
import { useAuthToken } from './auth';
import { useProject } from './projects';

const blogClient = new BlogApi(
  new Configuration({
    basePath: apiBasePath(),
    accessToken: async () => useAuthToken(),
  }),
);

export const useBlog = () => {
  const project = useProject({ required: true });

  return {
    blogs: {
      get: (blogId: string) => blogClient.getBlog({ project: toValue(project).id, blogId }),
      list: (options: Omit<BlogApiListBlogsRequest, 'project'>) =>
        blogClient.listBlogs({ project: toValue(project).id, ...options }),
      create: (createBlogRequest: CreateBlogRequest) =>
        blogClient.createBlog({ project: toValue(project).id, createBlogRequest }),
      delete: (blogId: string) => blogClient.deleteBlog({ project: toValue(project).id, blogId }),
      update: (blogId: string, updateBlogRequest: UpdateBlogRequest) =>
        blogClient.updateBlog({ project: toValue(project).id, blogId, updateBlogRequest }),
    },
  };
};
